import * as BufferLayout from "@solana/buffer-layout";
export class Field extends BufferLayout.Layout {
}
//# sourceMappingURL=Field.js.map